/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Seating_InvalidInputs */



/**
* | output |
* | --- |
* | "Invalid Seating" |
*
* @param {Rounds_Seating_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_invalid = /** @type {((inputs?: Rounds_Seating_InvalidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_InvalidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placement invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asientos inválidos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alocação Inválida")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disposizione Non Valida")
	return /** @type {LocalizedString} */ ("Invalid Seating")
});